<template>
  <vs-popup class="customer-so-popup"
            id="popup"
            title="CHECK CUSTOMER PO NUMBER"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <ValidationProvider vid="customer_po" name="customer_po" rules="required" v-slot="{ errors }">
            <small class="label font-medium mb-1 block">Enter Customer PO Number</small>
            <div class="flex items-center">
              <vs-input
                icon-pack="feather"
                icon="icon-search"
                @keyup.enter="onClickCheckPo()"
                v-model="customer_po"
                name="customer_po"
                class="w-full mr-2"
              />
              <vs-button @click.stop="onClickCheckPo" icon-pack="feather" icon="icon-search">Search</vs-button>
            </div>
            <span class="text-danger text-xs mt-1" v-if="errors[0]">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
      </div>

      <!-- Search results -->
      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <!-- Found existing orders alert -->
          <vs-alert
            v-if="is_searched && existing_orders.length > 0"
            color="warning"
            icon-pack="feather"
            icon="icon-alert-triangle"
            class="mb-4"
            :active="true">
            <span>Found <strong>{{ existing_orders.length }}</strong> previous order(s) with Customer PO <strong>"{{ customer_po }}"</strong>:</span>
          </vs-alert>

          <!-- No existing orders alert -->
          <vs-alert
            v-if="is_searched && existing_orders.length === 0"
            color="success"
            icon-pack="feather"
            icon="icon-check-circle"
            class="mb-4"
            :active="true">
            <span>No previous orders found with PO number <strong>"{{ customer_po }}"</strong>. You can safely proceed with this PO.</span>
          </vs-alert>

          <!-- Table of existing orders -->
          <div v-if="existing_orders.length > 0" class="overflow-x-auto border rounded-lg">
            <vs-table :data="existing_orders" stripe class="table-auto">
              <template slot="thead">
                <vs-th width="20%">ORDER CODE</vs-th>
                <vs-th width="25%">CUSTOMER</vs-th>
                <vs-th width="20%">CREATED DATE</vs-th>
                <vs-th width="25%">ITEMS</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span @click.stop="onClickViewOrder(tr.id)" class="text-primary font-bold cursor-pointer hover:underline flex items-center">
                      {{ tr.sample_order_code }}
                      <feather-icon icon="ExternalLinkIcon" svgClasses="w-3 h-3 ml-1 text-primary" />
                    </span>
                  </vs-td>

                  <vs-td>
                    <span class="font-medium">{{ tr.name || 'N/A' }}</span>
                  </vs-td>

                  <vs-td>
                    <span>{{ formatDate(tr.created_at) }}</span>
                  </vs-td>

                  <vs-td>
                    <div v-if="tr.formulation_items && tr.formulation_items.length" class="flex flex-col py-1">
                      <div v-for="(item, idx) in tr.formulation_items" :key="idx" class="mb-1 text-xs">
                        <span class="font-semibold text-primary">{{ item.formulation_code }}</span>
                      </div>
                    </div>
                    <span v-else class="text-muted text-xs">No items</span>
                  </vs-td>

                  <vs-td>
                    <vs-button
                      size="small"
                      type="border"
                      icon-pack="feather"
                      icon="icon-external-link"
                      @click.stop="onClickViewOrder(tr.id)">
                      View
                    </vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap items-center justify-end mt-6">
        <vs-button type="border" color="danger" @click.stop="open = false" class="mr-3 mt-2">Cancel</vs-button>
        <vs-button
          v-if="customer_po.length > 0 && is_searched"
          @click.stop="onClickProceedWithPo"
          color="primary"
          class="mt-2"
          icon-pack="feather"
          icon="icon-check">
          Create order with this Customer PO ({{ customer_po }})
        </vs-button>
      </div>

    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import moment from 'moment'

  const DropDownRepository = RepositoryFactory.get('drop_down')

  function initialState() {
    return {
      open: false,
      customer_po: '',
      existing_orders: [],
      customer_id: '',
      customer_lead_id: '',
      is_display_no_data_message: false,
      is_searched: false
    }
  }

  export default {
    name: 'ProductOrderCustomerPoCheckPopUp',
    data () {
      return initialState()
    },
    methods: {
      formatDate(date) {
        if (!date) return 'N/A'
        return moment(date).format('DD/MM/YYYY')
      },
      async openPopup (customer_id = '', customer_lead_id = '') {
        try {
          await Object.assign(this.$data, initialState())
          this.customer_id = customer_id
          this.customer_lead_id = customer_lead_id
          this.open = true
        } catch (error) {
          this.convertAndNotifyError(error)
        }
      },
      async onClickCheckPo() {
        if (!this.customer_po || !this.customer_po.trim()) {
          return
        }
        this.$vs.loading()
        try {
          this.is_display_no_data_message = false
          let query = `filter[po-number]=${this.customer_po.trim()}`
          if (this.customer_id) {
            query += `&customer-id=${this.customer_id}`
          }
          if(this.customer_lead_id){
            query += `&customer-lead-id=${this.customer_lead_id}`
          }
          const { data } = (await DropDownRepository.getAllSampleOrderList(0, query)).data
          this.existing_orders = data || []
          if (this.existing_orders.length === 0) {
            this.is_display_no_data_message = true
          }
          this.is_searched = true
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      onClickViewOrder(order_id) {
        let route = this.$router.resolve({path: `/pages/sample-orders/${order_id}`})
        window.open(route.href, '_blank')
      },
      onClickProceedWithPo() {
        this.$emit('setCustomerSamplePoNo', this.customer_po)
        this.open = false
      }
    },
    computed: {},
    async mounted () {},
    components: {
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .customer-so-popup >>> .vs-popup {
    min-width: 60% !important;
    max-width: 900px !important;
  }
</style>
